import React, { useState } from 'react';
import { SelectedPatientContext } from "./SelectedPatientContext";
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { Home } from './home';
import { Dashboard } from './control-panel/dashboard';
import { Scheduler } from './control-panel/scheduler';
import { Therapists } from './control-panel/therapists';
import { Patients } from './control-panel/patients';
import { Account } from './control-panel/account';
import { Preferences } from './control-panel/preferences';
import { About } from './control-panel/about';
import { Header } from './header';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Schedules } from './control-panel/schedules';
import { AllowedScenariosSelection } from './control-panel/set-scenario-constraints';
import { BiofeedbackChart } from './control-panel/biofeedback';

export const App: React.FunctionComponent = () => {
  const [selectedPatientId, setSelectedPatientId] = useState(0);

  return (
    <BrowserRouter>
      <FluentProvider theme={webLightTheme} className="root">
        <div className="base-layout">
          <Header />
          <SelectedPatientContext.Provider value={{ selectedPatientId, setSelectedPatientId }}>
            <Routes>
              <Route index element={<Home />} />
              <Route path="biofeedback" element={<BiofeedbackChart />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="scheduler" element={<Scheduler />} />
              <Route path="scheduler/:id" element={<Scheduler />} />
              <Route path="schedules" element={<Schedules />} />
              <Route path="therapists" element={<Therapists />} />
              <Route path="patients" element={<Patients />} />
              <Route path="account" element={<Account />} />
              <Route path="preferences" element={<Preferences />} />
              <Route path="about" element={<About />} />
              <Route path="set-scenario-constraints" element={<AllowedScenariosSelection />} />
              <Route path="*" element={<div>404</div>} />
            </Routes>
          </SelectedPatientContext.Provider>
        </div>
      </FluentProvider>
    </BrowserRouter>
  );
};
